<template>
    <div>
        <el-form class="form" ref="form" label-width="80px">
            <el-checkbox class="checkbox" v-model="checked"></el-checkbox>
            <el-form-item label="大小" style="margin-bottom:12px;">
                <el-input v-model="data" type="textarea" :autosize="{minRows:1}" resize="none"></el-input>
            </el-form-item>
            <div class="examples">
                <el-button class="color-grey" type="info" size="mini" @click="fill(10)">小</el-button>
                <el-button class="color-grey" type="info" size="mini" @click="fill(15)">中(基准)</el-button>
                <el-button class="color-grey" type="info" size="mini" @click="fill(20)">大</el-button>
            </div>
        </el-form>
    </div>
</template>
<script>
export default {
    name: 'Size',
    props: {
        value: Object
    },
    watch: {
        checked(newVal, oldVal) {
            this.submit()
        },
        data(newVal, oldVal) {
            this.submit()
        },
    },
    data() {
        return {
            type: 'Size',
            checked: false,
            data: 15,
        }
    },
    created() {},
    mounted() {
        this.init()
    },
    methods: {
        fill(size) {
            this.data = size
        },
        init() {
            this.checked = this.value.checked
            this.data = parseInt(this.value.value)
            if (this.data == null) {
                this.data = 15
            }
        },
        submit() {
            var data = {
                type: this.type,
                checked: this.checked,
                value: this.data
            }
            this.$emit('input', data)
        },
    },
}
</script>
<style lang="scss">
.form {
    display: flex;
    align-items: center;
}

.examples {
    margin-left: 0.533rem;

    .color-grey {
        background: #989EA4;
    }

    .color-black {
        background: #000000;
    }
}
</style>